import LandingPage from './LandingPage';

function Dashboard({ user }) {
  return <LandingPage user={user} />;
}

export default Dashboard;